import React, { useState, useEffect } from "react";
import Select from "react-select";
import styles from "../DailySummaryTab.module.css"; // Assuming shared styles or create a new one

// Employee Selection Modal
export const EmployeeSelectionModal = ({
  isOpen,
  onClose,
  onSelectEmployee,
  allEmployees,
  existingEmployees,
  selectedEmployees = [],
  onSelectionChange,
}) => {
  const [localSelectedEmployees, setLocalSelectedEmployees] =
    useState(selectedEmployees);

  if (!isOpen) return null;

  // Filter out employees already in the list
  const availableEmployees = allEmployees.filter(
    (employee) =>
      !existingEmployees.some(
        (existing) => existing.employee_id === employee.employee_id
      )
  );

  const handleSelectEmployee = (selected) => {
    const next = selected || [];
    setLocalSelectedEmployees(next);
    onSelectionChange?.(next);
  };

  const handleAddEmployees = () => {
    const current = onSelectionChange
      ? selectedEmployees
      : localSelectedEmployees;
    if (current.length === 0) return;

    // If single employee was selected (not array)
    if (!Array.isArray(current)) {
      onSelectEmployee([current]);
    } else {
      onSelectEmployee(current);
    }

    setLocalSelectedEmployees([]);
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h3>Select Employees</h3>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <Select
            options={availableEmployees}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.employee_id}
            onChange={handleSelectEmployee}
            value={
              onSelectionChange ? selectedEmployees : localSelectedEmployees
            }
            placeholder="Search for employees..."
            className={styles.employeeSelect}
            isMulti
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />

          <div className={styles.modalActions}>
            <button className={styles.cancelButton} onClick={onClose}>
              Cancel
            </button>
            <button
              className={styles.confirmButton}
              onClick={handleAddEmployees}
              disabled={selectedEmployees.length === 0}
            >
              Add Selected Employees
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
